import { PurcsApi } from '@vp/react-product-preview';

// These are the default values that the PurcsPreview component uses when calling the PurcsApi. We can similarly leverage these as fallback values in our own API call
export const defaultPurcsPreviewOptions = {
  purcsOrigin: 'https://lookup.previews.cimpress.io',
  workEntityServiceOrigin: 'https://workentityservice.design.vpsvc.com',
  requestor: 'purcs-client',
  tenantType: 'merchants',
  tenantId: 'vistaprint-prod',
  vistaprintTenant: 'vistaprint',
  promotiqueTenant: 'promotique',
  locale: 'en-IE',
  purpose: 'design.studio.review',
  width: 1000,
};
export function getDefaultPurcsPreviewUrl({
  purcsData,
  productKey,
  locale,
  requestor,
}) {
  const { src: defaultPreviewUrl } = PurcsApi.getDefaultView(
    defaultPurcsPreviewOptions.purcsOrigin,
    purcsData.tenantId || defaultPurcsPreviewOptions.tenantId,
    purcsData.locale || locale || defaultPurcsPreviewOptions.locale,
    productKey,
    null,
    purcsData.optionSelections,
    requestor || defaultPurcsPreviewOptions.requestor,
    defaultPurcsPreviewOptions.purpose,
    purcsData.previewInstructionsUri,
    defaultPurcsPreviewOptions.width
  );

  return defaultPreviewUrl;
}
